import { createContext, useContext, useState, useEffect } from 'react';

const MobileContext = createContext();

export function MobileProvider({ children }) {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [forceMobile, setForceMobile] = useState(null); // null = auto, true = force mobile, false = force desktop

  useEffect(() => {
    const check = () => setIsMobileDevice(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const isMobile = forceMobile !== null ? forceMobile : isMobileDevice;

  const toggleMode = () => {
    if (forceMobile === null) {
      setForceMobile(!isMobileDevice);
    } else {
      setForceMobile(forceMobile ? false : true);
    }
  };

  const resetToAuto = () => setForceMobile(null);

  return (
    <MobileContext.Provider value={{ isMobile, isMobileDevice, forceMobile, toggleMode, resetToAuto }}>
      {children}
    </MobileContext.Provider>
  );
}

export function useMobile() {
  return useContext(MobileContext);
}
